export default [
  // {
  //   name: 'workspace_access',
  //   label: 'labels.workspace_access',
  //   permissionKey: 'workspace_access'
  // }
]
